module.exports = __webpack_public_path__ + "static/media/icon_orden.86de425f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/icon_orden.svg
// module id = 337
// module chunks = 0